import api from "./apiBase";

function associatePrinter(data) {
  return api.post("/printers-users", data);
}

function listPrinters(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`/printers?${query}`);
}

function listPrintersUsers(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`/printers-users?${query}`);
}

function updatePrinterUserName(id, name) {
  return api.patch(`/printers-users/${id}`, { name });
}

function removeAssociation(id) {
  return api.delete("/printers-users/" + id);
}

function requestPrinter(data) {
  return api.post("/printers-requested", data);
}

export {
  associatePrinter,
  listPrinters,
  listPrintersUsers,
  updatePrinterUserName,
  removeAssociation,
  requestPrinter,
}
